export const RESET = 'ACCOUNT_LIST_RESET'
export const SET_ITEMS = 'ACCOUNT_LIST_SET_ITEMS'
export const SET_ERROR = 'ACCOUNT_LIST_SET_ERROR'
export const SET_SELECT_ITEMS = 'ACCOUNT_LIST_SET_SELECT_ITEMS'
export const SET_VIEW = 'ACCOUNT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'ACCOUNT_LIST_TOGGLE_LOADING'
